import { AnaColumn } from "../forms-template.service";

export const automezzi: AnaColumn[] = [
    {
      itemType: "group", colCount: "1", data: [
        { type: 'campo', dataField: "id", dataType: "", caption: "id Automezzo" },
      ]
    },
    {
      itemType: "group", colCount: "1", data: [
        {
          type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione",
  
        },
        { type: 'campo', dataField: "targa", dataType: "", caption: "Targa" }]
    }];